import { version } from "../../package.json";
window.APP_VERSION = version;

export const theme = process.env.VUE_APP_THEME || "default";

// Vilela comparte la misma configuración de features que Deragopyan
const hasDeragopyanConfig = ["deragopyan", "vilella"].includes(theme);

export const apiUrl = process.env.VUE_APP_API_URL || "http://localhost:3000";

export const landingUrl =
  process.env.VUE_APP_LANDING_URL || "http://localhost:5173";

export const shopUrl = "https://gpsfarma.com/ofertas.html";

export const s3Url =
  process.env.VUE_APP_S3_URL || "https://gizhealth-local.s3.amazonaws.com";

export const audience = process.env.VUE_APP_AUDIENCE || "dashboard";

export const marketingWebsiteUrl =
  process.env.VUE_APP_MARKETING_WEBSITE_URL ||
  "https://gizhealth.com/patient.html";

export const iOSAppStoreUrl =
  process.env.VUE_APP_IOS_APP_STORE_URL || "javascript:;";

export const androidAppStoreUrl =
  process.env.VUE_APP_ANDROID_APP_STORE_URL || "javascript:;";

export const loginRedirectURL =
  process.env.VUE_APP_SCORES_REDIRECT_URL ||
  "https://dashboard.gizhealth.com/login";

export const supportEmail =
  process.env.VUE_APP_SUPPORT_EMAIL || "soporte@quantuxsalud.com";

export const mobileAppName =
  process.env.VUE_APP_MOBILE_APP_NAME || "Consultorio Quantux";

export const organizationId = process.env.VUE_APP_ORGANIZATION_ID || null;

export const enableChat =
  process.env.VUE_APP_ENABLE_CHAT === "true" ? true : false;

export const enableScores =
  process.env.VUE_APP_ENABLE_SCORES === "true" ? true : false;

export const enableEpisodeCreation =
  process.env.VUE_APP_ENABLE_EPISODE_CREATION === "false" ? false : true;

export const isIndicationsEnabled = true;
export const isAppointmentsEnabled = true;
export const isVideoRoomEnabled = true;

export const isPatientEvolutionEnabled =
  process.env.VUE_APP_PATIENT_EVOLUTION_ENABLED === "false" ? false : true;

// This enables Seguimientos
export const isMonitoringEnabled =
  process.env.VUE_APP_MONITORING_ENABLED === "false" ? false : true;

// This enables Protocolos
export const isProtocolsEnabled =
  process.env.VUE_APP_PROTOCOLS_ENABLED === "false" ? false : true;

// This enables Tasks
export const isTasksEnabled =
  process.env.VUE_APP_TASKS_ENABLED === "false" ? false : true;

// This enables programs
export const isProgramsEnabled =
  process.env.VUE_APP_PROGRAMS_ENABLED === "false" ? false : true;

// This enables admission for Derago
export const isAdmissionForDeragopyanEnabled =
  process.env.VUE_APP_DERAGOPYAN_ADMISSION_ENABLED === "false" ? false : true;

const videoRoomEngines = ["twilio", "jitsi"];
export const videoRoomEngine = videoRoomEngines.includes(
  process.env.VUE_APP_VIDEO_ROOM_ENGINE
)
  ? process.env.VUE_APP_VIDEO_ROOM_ENGINE
  : "twilio";

export const isFormPrintingEnabled =
  process.env.VUE_APP_ENABLE_EVENTS_PRINT === "true" ? true : false;

export const isMassiveEnabled =
  process.env.VUE_APP_ENABLE_MASSIVE_ACTIONS === "true" ? true : false;

export const isAppointmentBookingEnabled =
  process.env.VUE_APP_ENABLE_APPOINTMENT_BOOKING === "false" ? false : true;

export const isAgendaVirtualEnabled =
  process.env.VUE_APP_AGENDA_VIRTUAL_ENABLED === "true" ? true : false;
export const isAgendaPricingEnabled =
  process.env.VUE_APP_AGENDA_PRICING_ENABLED === "false" ? false : true;
export const isOrdersCrmEnabled =
  process.env.VUE_APP_ORDERS_CRM_ENABLED === "true" ? true : false;

export const isManualManagementEnabled =
  process.env.VUE_APP_MANUAL_MANAGEMENT_ENABLED === "false" ? false : true;

export const isAppointmentStatusEnabled =
  !hasDeragopyanConfig &&
  (process.env.VUE_APP_APPOINTMENT_STATUS_ENABLED === "true" ? true : false);

export const isConsultationOptionsCNCEnabled =
  process.env.VUE_APP_CONSULTATION_OPTIONS_CNC_ENABLED === "true";

export const isHCFormsEnabled =
  process.env.VUE_APP_HC_FORMS_ENABLED === "false" ? false : true;

export const isObservationEditEnabled =
  process.env.VUE_APP_OBSERVATIONS_EDIT_ENABLED === "true";

export const isObservationsEnabled =
  hasDeragopyanConfig || isObservationEditEnabled;

export const isAdmissionTimestampEnabled = true;

export const isAppointmentRelocationHiddenForBackoffice = hasDeragopyanConfig;
export const isInstitutionCreationHiddenForAdminDoctor = hasDeragopyanConfig;
export const isPrescriptionsHiddenForDoctor =
  process.env.VUE_APP_PRESCRIPTIONS_HIDDEN_FOR_DOCTOR === "true";
export const isSlotDisableHiddenForDoctor =
  process.env.VUE_APP_SLOT_DISABLE_HIDDEN_FOR_DOCTOR === "true";
export const isPatientLockHiddenForDoctor =
  process.env.VUE_APP_PATIENT_LOCK_HIDDEN_FOR_DOCTOR === "true";
export const arePrescriptionNotesAndCertificatesEnabled = hasDeragopyanConfig;
export const isAssistantHistoricalAgendaEnabled = hasDeragopyanConfig;

export const areImagesAndLabButtonsHidden = theme === "vilella";

export const isHL7AgendaEnabled =
  process.env.VUE_APP_HL7_AGENDA_ENABLED === "true";
export const arePrescriptionsForDoctorOnly = hasDeragopyanConfig;
export const isPatientPdfDownloadExtended = hasDeragopyanConfig;
export const isManualPatientCreationRestricted = hasDeragopyanConfig;

export const isPatientManagementRestricted = hasDeragopyanConfig;
export const isPatientFollowupRestricted = hasDeragopyanConfig;

export const areFollowupsRestrictedForBackoffice = hasDeragopyanConfig;
export const areProtocolsRestrictedForBackoffice = hasDeragopyanConfig;
export const areValidationsRestrictedForBackoffice = hasDeragopyanConfig;

export default {
  theme,
  apiUrl,
  landingUrl,
  shopUrl,
  s3Url,
  audience,
  marketingWebsiteUrl,
  iOSAppStoreUrl,
  androidAppStoreUrl,
  supportEmail,
  mobileAppName,
  organizationId,
  loginRedirectURL,
};
